module.exports = __webpack_public_path__ + "img/4.52e933ab.jpg";